import React, { Component } from "react";
import App from "./Chartnew";
import ReactMultiSelectCheckboxes from "react-multiselect-checkboxes";
import axios from "axios";
import authHeader from "../services/auth-header";
import fileDownload from "js-file-download";
import reseticon from "../image/reset.png";

class Body extends Component {
  /*************************STATE************************/
  constructor(props) {
    super(props);
    this.state = {
      imei: [],
      startdate: "",
      enddate: "",
      time: "",
      reference: "",
      calibration: "",
      parameter: "",
      datadownload: "",
      slicetime: "",
      selectedOption: [],
    };
  }

  /*************************FUNCTIONS************************/
  componentDidUpdate() {
    if (this.props.invalidtoken == "Token is invalid !!") {
      return localStorage.clear(), window.location.reload();
    }
  }

  Country() {
    return this.props.data1.map((data) => ({
      label: data.properties.imei,
      value: data.properties.imei,
    }));
  }

  handleImei = (selectedOption) => {
    this.setState({ selectedOption });
  };

  handleStartDate = (event) => {
    this.setState({
      startdate: event.target.value,
    });
  };

  handleEnddate = (event) => {
    this.setState({
      enddate: event.target.value,
    });
  };

  handleTime = (event) => {
    this.setState({
      time: event.target.value,
    });
  };

  handleSliceTime = (event) => {
    this.setState({
      slicetime: event.target.value,
    });
  };

  handleReferencee = (event) => {
    this.setState({
      reference: event.target.value,
    });
  };

  // handleCalibration = event => {
  //   this.setState({
  //     calibration: event.target.value
  //   })
  // }

  handleParameter = (event) => {
    this.setState({
      parameter: event.target.value,
    });
  };

  resetField = () => {
    this.setState({
      imei: [],
      startdate: "",
      enddate: "",
      time: "",
      reference: "",
      // calibration:'',
      parameter: "",
      datadownload: "",
      slicetime: "",
      selectedOption: [],
    });
  };

  /*************************DOWNLOAD DATA************************/

  handleDownload = (url, filename) => {
    axios
      .get(url, {
        responseType: "blob",
        headers: authHeader(),
      })
      .then((res) => {
        fileDownload(res.data, filename);
      });
  };

  render() {
    /*************************CUSTOM STYLE FOR IMEI INPUT FIELD************************/

    const customStyles = {
      option: (provided, state) => ({
        ...provided,
        color: state.isSelected ? "red" : "black",
        width: "226px",
        padding: 20,
      }),
      dropdownButton: () => ({
        width: "220px",
        display: "inline-flex",
        border: "1px solid #ced4da",
        height: "calc(1.5em + .75rem + 2px)",
        borderRadius: ".25rem",
        textAlign: "left",
        color: "#979797",
        backgroundColor: "#fff",
        margin: "5px",
      }),
    };
    const { selectedOption } = this.state;

    /*************************MAIN CODE************************/

    return (
      <div className="chart-box">
        <div className="chart-interior-box">
          <form className="mx-4">
            <div className="row">
              <div className="Device-id">
                <p className="inputLable">Device ID</p>
                <ReactMultiSelectCheckboxes
                  placeholderButtonLabel="Select upto 5 Devices ID"
                  styles={customStyles}
                  options={this.Country()}
                  value={selectedOption}
                  onChange={this.handleImei}
                  isMulti
                />
              </div>

              <div className="start-date">
                <p className="inputLable">Start Date</p>
                <input
                  type="datetime-local"
                  className="custom-select-chart-input"
                  placeholder="YYYYMMDD"
                  name="startDate"
                  value={this.state.startdate}
                  onChange={this.handleStartDate}
                />
              </div>

              <div className="end-date">
                <p className="inputLable">End Date</p>
                <input
                  type="datetime-local"
                  className="custom-select-chart-input"
                  placeholder="YYYYMMDD"
                  name="endDate"
                  value={this.state.enddate}
                  onChange={this.handleEnddate}
                />
              </div>

              <div className="average-time">
                <p className="inputLable">Average Time</p>
                <select
                  className="custom-select-chart-input"
                  value={this.state.time}
                  onChange={this.handleTime}
                >
                  <option value="select">Select</option>
                  <option value="mm">Minute</option>
                  <option value="hh">Hour</option>
                  <option value="dd">Day</option>
                </select>
              </div>

              <div className="slice-time">
                <p className="inputLable">Slice Time</p>
                <input
                  type="number"
                  placeholder="Enter number from 1-60"
                  min="0"
                  max="60"
                  className="custom-select-chart-input"
                  value={this.state.slicetime}
                  onChange={this.handleSliceTime}
                />
              </div>

              <div className="reference-imei">
                <p className="inputLable">Reference Imei</p>
                <select
                  className="custom-select-chart-input"
                  value={this.state.reference}
                  onChange={this.handleReferencee}
                >
                  <option value="select">Select</option>
                  {this.props.data2.map((obj) => (
                    <option value={obj.imei} key={obj.imei}>
                      {obj.locality} - {obj.imei}
                    </option>
                  ))}
                </select>
              </div>

              <div className="pollutant">
                <p className="inputLable">Pollutant</p>
                <select
                  className="custom-select-chart-input"
                  value={this.state.parameter}
                  onChange={this.handleParameter}
                >
                  <option value="select">Select</option>
                  <option value="pm2.5">PM2.5</option>
                  <option value="pm10">PM10</option>
                  <option value="ozone">ozone</option>
                  <option value="no2">no2</option>
                  <option value="o3op1">o3op1</option>
                  <option value="o3op2">o3op2</option>
                </select>
              </div>

              <div className="resetInput">
                <button type="button" className="reset-button">
                  <a className="reset-text" onClick={this.resetField}>
                    Reset
                  </a>
                  <img
                    src={reseticon}
                    alt="reset"
                    style={{ height: "15px", paddingLeft: "10px" }}
                  />
                </button>
              </div>

              {/* <div className="col-3 font-weight-bold">
                
                <p className="inputLable">Calibration algorithm</p>
                  <select className="custom-select "  value={this.state.calibration} onChange={this.handleCalibration}>
                    <option value="select" disabled="disabled">Select</option>
                    <option value="none">None</option>
                    <option value="lr">LR</option>
                    <option value="mlr">MLR</option>
                    <option value="knn">KNN</option>
                    <option value="lmm">LMM</option>
                    <option value="calib_ref">CALIB_REF</option>
                    <option value="calib_rh_temp_ref">CALIB_RH_TEMP_REF</option>
                    <option value="calib_rh_ref">CALIB_RH_REF</option>
                    <option value="calib_rh">CALIB_RH</option>
                  </select>
                
              </div>         */}
            </div>
            {/* <div className="row my-3">
              <div className="col-6">
                <button
                  type="button"
                  className="btn btn-success float-right mr-2"
                  onClick={() => {
                    this.handleDownload(
                      `http://atmos.urbansciences.in/adpl/getData/imei/${
                        this.state.selectedOption !== undefined
                          ? this.state.selectedOption.map((e) => e.label)
                          : ""
                      }/startdate/${this.state.startdate}/enddate/${
                        this.state.enddate
                      }/ts/${this.state.time}/avg/${
                        this.state.slicetime
                      }/refimei/${this.state.reference}/para/${
                        this.state.parameter
                      }/cm/lr/type/csv/username/mpcb`,
                      "Chart_data.csv"
                    );
                  }}
                >
                  Download Data
                </button>
              </div>
              <div className="col-6">
                <button
                  type="button"
                  className="btn btn-danger"
                  style={{ width: "142px" }}
                >
                  <a
                    style={{
                      color: "#fff",
                      fontWeight: "bold",
                      textDecoration: "none",
                    }}
                    onClick={this.resetField}
                  >
                    Reset Input
                  </a>
                </button>
              </div>
            </div> */}
          </form>

          {/* ****************************PASSING DATA TO OTHER PAGE************************** */}
          <App
            url={`https://atmos.urbansciences.in/adpl/getData/imei/${this.state.selectedOption !== undefined
                ? this.state.selectedOption.map((e) => e.label)
                : ""
              }/startdate/${this.state.startdate}/enddate/${this.state.enddate
              }/ts/${this.state.time}/avg/${this.state.slicetime}/refimei/${this.state.reference
              }/para/${this.state.parameter}/cm/lr/type/json/username/mpcb`}
            onClick={this.resetField}
            selectedOption={this.state.selectedOption}
            download={`https://atmos.urbansciences.in/adpl/getData/imei/${this.state.selectedOption !== undefined
                ? this.state.selectedOption.map((e) => e.label)
                : ""
              }/startdate/${this.state.startdate}/enddate/${this.state.enddate
              }/ts/${this.state.time}/avg/${this.state.slicetime}/refimei/${this.state.reference
              }/para/${this.state.parameter}/cm/lr/type/csv/username/mpcb`}
          />
        </div>
      </div>
    );
  }
}
export default Body;
